

































import Vue from 'vue'

declare interface RoomSizeItem {
  text: string,
  value: number,
}

export type DataType = {
  roomSize: number,
  roomSizeItems: RoomSizeItem[], 
}

export default Vue.extend({
  name: 'CardRoomSize',

  data(): DataType {
    return {
      roomSize: 2,
      roomSizeItems: [
        {
          text: '2',
          value: 2,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '5',
          value: 5,
        },
        {
          text: '6',
          value: 6,
        },
        {
          text: '7',
          value: 7,
        },
        {
          text: '8',
          value: 8,
        },
        {
          text: '9',
          value: 9,
        },
        {
          text: '10',
          value: 10,
        },
      ],        
    }
  },

  methods: {
    setRoomSize(): void {
      this.$emit('setRoomSize', this.roomSize)
    },

    cancel(): void {
      this.$emit('cancel')
    }
  }
})
